import { render, staticRenderFns } from "./ui-info-right-block-return.vue?vue&type=template&id=0084a66a&scoped=true&"
import script from "./ui-info-right-block-return.vue?vue&type=script&lang=js&"
export * from "./ui-info-right-block-return.vue?vue&type=script&lang=js&"
import style0 from "./ui-info-right-block-return.vue?vue&type=style&index=0&id=0084a66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084a66a",
  null
  
)

export default component.exports